export const navItems = [
  {
    name: 'Nav.wellPadPreparation',
    to: 'wellPadPreparation',
  },
  {
    name: 'Nav.wells',
    to: 'wells',
  },
  {
    name: 'Nav.schedule',
    to: 'schedule',
  },
];
